import { all as both, call, put, takeLatest } from 'redux-saga/effects';
import { GET_RULES } from './constants';
import { setRules } from './actions';
import { all, allPages } from '../services/rules';

function* getRulesTask() {
  const [sections, pages] = yield both([call(all), call(allPages)]);
  yield put(setRules(sections, pages));
}

function* getRulesWatcher() {
  yield takeLatest(GET_RULES, getRulesTask);
}

export default [
  getRulesWatcher,
];
